module.exports = __webpack_public_path__ + "static/media/quesadilla.66b21782.png";